export default __webpack_public_path__ + "static/media/20210819182535.fac736b6.png";